module.exports = __webpack_public_path__ + "static/media/help.61ace590.svg";